import { render, staticRenderFns } from "./TournamentEditActivities.vue?vue&type=template&id=4a8ea0ab&scoped=true"
import script from "./TournamentEditActivities.vue?vue&type=script&lang=js"
export * from "./TournamentEditActivities.vue?vue&type=script&lang=js"
import style0 from "./TournamentEditActivities.vue?vue&type=style&index=0&id=4a8ea0ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8ea0ab",
  null
  
)

export default component.exports